import { useRef } from 'react';
import { useMount } from 'ahooks';

interface UseScrollIntoViewMountOptions {
    active?: boolean;
}

const useScrollIntoViewMount = ({ active }: UseScrollIntoViewMountOptions) => {
    const elementRef = useRef<HTMLDivElement>(null);
    useMount(() => {
        if (!elementRef.current || active) return;
        elementRef.current.scrollIntoView({
            block: 'start',
            behavior: 'smooth',
        });
    });
    return { elementRef };
};

export { useScrollIntoViewMount };
